import React, { Component } from 'react'
import { Grid, Row, Col, FormGroup, Radio } from 'react-bootstrap'

import i18next from 'i18next'

import styles from './styles/questionnaire.scss'
import illustration from './../assets/images/wopi-wide.png'

const roles = [
  {
    role: 'manager',
    description: 'role_manager'
  },
  {
    role: 'other',
    description: 'role_other'
  }
]

export default class Wopi360Setup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      role: '',

      form: {
        isValid: false
      }
    }
  }

  handleContinue = () => {
    this.props.onSelectRole(this.state.role)
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, this.validateState)
  }

  validateState() {
    const validate = () => {
      return {
        isValid: roles.map(role => role.role).includes(this.state.role)
      }
    }

    this.setState({
      form: validate()
    })
  }

  render() {
    const { language } = this.props

    const t = text => i18next.t(text, { lng: language, ns: 'wopi360Test' })

    return (
      <Grid className={styles.wopi360Introduction}>
        <Row>
          <Col smOffset={3} sm={6}>
            <h1>{t('select_role')}</h1>

            <p>
              <small>{t('select_role_description')}</small>
            </p>

            <FormGroup controlId="role">
              {roles.map((role, i) => (
                <Radio key={i} name="role" readOnly onClick={this.handleChange} value={role.role}>
                  {t(role.description)} <small>{t(role.smallDescription)}</small>
                </Radio>
              ))}
            </FormGroup>

            <div className={styles.buttonContainer}>
              <button
                className={styles.button}
                onClick={this.handleContinue}
                disabled={!this.state.form.isValid}
              >
                {t('continue')}
              </button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <img className={styles.illustration} src={illustration} />
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360Setup.js